import { EventDispatcher, inject } from "@spawn/core";
import { RevealEvents } from "@spawn/reveal";
import { AutoplayController, UiEvents } from "@spawn/slot-machine";
import { merge } from "rxjs";

export class NrgAutoplayController extends AutoplayController {
	@inject protected eventDispatcher!: EventDispatcher;

	constructor() {
		super();
		this.subscriptions.add(
			merge(
				this.eventDispatcher.event$(RevealEvents.CoverSymbol), //
				this.eventDispatcher.event$(UiEvents.ModalClose)
			).subscribe(() => this.updateRemainingSpins())
		);
	}
}
